/* eslint-disable lingui/no-unlocalized-strings */
import { Linkedin, Mail } from "lucide-react";
import { Link } from "react-router-dom";

import { track } from "@/client/analytics/mixpanel";
import { env } from "@/client/config/env";

import { getSegment, INSTITUTIONS_PATH } from "../../../institutions/content";

const productLinks = [
  { href: "/dashboard/jobs", label: "Job Search" },
  { href: "/practice-interview", label: "Practice Interview" },
  { href: "/dashboard/spotlight-intro", label: "Spotlight Intro" },
  { href: "/dashboard/application-status", label: "Application Tracker" },
  { href: INSTITUTIONS_PATH, label: "For Educational Institutes" },
];

const companyLinks = [
  { href: "/blog", label: "Blog" },
  { href: "/careers", label: "Careers" },
  { href: "/privacy", label: "Privacy" },
  { href: "/terms", label: "Terms" },
];

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#10192e] text-white">
    <div className="mx-auto max-w-[1320px] px-6 py-16 sm:px-8 lg:px-12">
      <div className="grid gap-12 md:grid-cols-[1.4fr_0.6fr_0.6fr]">
        <div>
          <p className="font-noto-serif text-3xl">theResume</p>
          <p className="mt-4 max-w-[29rem] text-sm leading-relaxed text-white/55">
            Introduce yourself with Spotlight. Practice interviews out loud. Build a resume that
            represents you—and prepare for your next opportunity.
          </p>
          <div className="mt-7 flex items-center gap-3">
            <a
              href="https://www.linkedin.com/company/theresume-io/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="theResume on LinkedIn"
              className="flex size-9 items-center justify-center rounded-full border border-white/15 text-white/60 transition hover:border-white/30 hover:text-white"
            >
              <Linkedin className="size-4" />
            </a>
            <a
              href={`mailto:${env.VITE_SUPPORT_EMAIL}`}
              aria-label={`Email ${env.VITE_SUPPORT_EMAIL}`}
              className="flex size-9 items-center justify-center rounded-full border border-white/15 text-white/60 transition hover:border-white/30 hover:text-white"
            >
              <Mail className="size-4" />
            </a>
          </div>
        </div>

        <FooterColumn heading="Product" links={productLinks} />
        <FooterColumn heading="Company" links={companyLinks} />
      </div>

      <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-7 text-xs text-white/60 sm:flex-row sm:items-center sm:justify-between">
        <p>© 2026 theResume. All rights reserved.</p>
        <p>Built for careers that keep changing.</p>
      </div>
    </div>
  </footer>
);

const FooterColumn = ({
  heading,
  links,
}: {
  heading: string;
  links: { href: string; label: string }[];
}) => (
  <div>
    <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-white/60">{heading}</p>
    <ul className="mt-5 space-y-3">
      {links.map((link) => (
        <li key={link.href}>
          <Link
            to={link.href}
            onClick={
              link.href === INSTITUTIONS_PATH
                ? () =>
                    track("institutions_cta_click", {
                      location: "footer",
                      action: "navigation",
                      segment: getSegment(window.location.search),
                    })
                : undefined
            }
            className="text-sm text-white/65 transition hover:text-white"
          >
            {link.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);
